import { Home, IconProps } from 'grommet-icons';

export const FacilityIcon: React.FC<IconProps> = (props) => <Home size="24px" color="brand" {...props} />;
